<template>
  <div>
    <b-form-group>
      <label :for="label" class="sr-only">{{ label }}</label>
      <input :id="label" :value="value" :type="type" :placeholder="label" class="form-control" @input="setValue">
      <validation-errors :validation-errors="validationErrors"/>
    </b-form-group>
  </div>
</template>

<script>
import validationErrors from './validation-errors'

export default {
  components: {
    validationErrors
  },
  props: {
    value: {
      type: String,
      required: false,
      default: ''
    },
    label: {
      type: String,
      required: true
    },
    mutation: {
      type: String,
      required: true
    },
    type: {
      type: String,
      required: true
    },
    validationErrors: {
      type: Array,
      required: false,
      default () {
        return []
      }
    }
  },
  methods: {
    setValue (e) {
      this.$store.commit(this.mutation, e.target.value)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/common/form/input.vue